import { Trans } from "react-i18next";

const onboardingSettingsList = [
  {
    name: "mobileNumberSetting",
    label: (
      <Trans i18nKey="page.settings.onboarding.form.mobileNumberSetting" />
    ),
    disabled: true,
  },
  {
    name: "dateBirthSetting",
    label: <Trans i18nKey="page.settings.onboarding.form.dateBirthSetting" />,
    disabled: false,
  },
  {
    name: "addressSetting",
    label: <Trans i18nKey="page.settings.onboarding.form.addressSetting" />,
    disabled: false,
  },
  {
    name: "postCodeSetting",
    label: <Trans i18nKey="page.settings.onboarding.form.postCodeSetting" />,
    disabled: false,
  },
  {
    name: "citySetting",
    label: <Trans i18nKey="page.settings.onboarding.form.citySetting" />,
    disabled: false,
  },
  {
    name: "genderSetting",
    label: <Trans i18nKey="page.settings.onboarding.form.genderSetting" />,
    disabled: false,
  },
  {
    name: "emergencyContactSetting",
    label: (
      <Trans i18nKey="page.settings.onboarding.form.emergencyContactSetting" />
    ),
    disabled: false,
  },
  {
    name: "personalNumberSetting",
    label: (
      <Trans i18nKey="page.settings.onboarding.form.personalNumberSetting" />
    ),
    disabled: false,
  },
  {
    name: "pictureSetting",
    label: <Trans i18nKey="page.settings.onboarding.form.pictureSetting" />,
    disabled: false,
  },
] as const;

export { onboardingSettingsList };
